import React from 'react'

function Header() {
  return (
    <header className="w-full py-4 px-4 sm:px-6 lg:px-8 animate-fade-in-down">
      <div className="max-w-6xl mx-auto flex justify-center">
        <img 
          src="/cp-logo-800.png" 
          alt="Companion Promise" 
          className="h-24 sm:h-32 w-auto" 
        />
      </div>
    </header>
  )
}

export default Header